/* import CCM JSON */
import jsonCategories from './CCM/models/CCM_CATEGORIES.json';
import jsonFields from './CCM/models/CCM_FIELDS.json';

/* CCM JSON interfaces */
export interface CCM_CATEGORIES {
  [category: string]: {
    ccm_fields: Array<string>;
    keywords: Array<string>;
    name: string;
    sourcetypes: Array<string>;
  };
}

export interface CCM_FIELDS {
  [field: string]: {
    name: string;
    description: string;
    permutations: Array<string>;
  };
}

/* export CCM JSON interfaces */
export const categories: CCM_CATEGORIES = <CCM_CATEGORIES>jsonCategories;
export const fields: CCM_FIELDS = <CCM_FIELDS>jsonFields;
